<template>
    <v-card :class="'card fill-height d-flex flex-column elevation-0 ' + cardProps.cardClass">
        <v-img 
            v-if="item.ImgThumb"
            :min-height="imgHeight" 
            :max-height="imgHeight"
            :src="item.ImgThumb[0].url" 
            @click="openDialog(item)"
            :contain="cardProps.contain"
            class="contrast">
            <div class="d-flex align-start fill-height pa-3">
                <v-tooltip v-if="item.State" right color="black">
                    <template v-slot:activator="{ on }">
                        <v-chip small color="primary" v-on="on">{{ item.State }}</v-chip>
                    </template>
                    <span>{{ item.City }}, {{ item.State }}</span>
                </v-tooltip>
                <v-tooltip v-if="item.Instagram" bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon v-if="item.Instagram" v-on="on" color="white" class="grey darken-2 rounded mt-auto ml-auto">
                            mdi-instagram
                        </v-icon>
                    </template>
                    <span>{{ item.Instagram }}</span>
                </v-tooltip>
            </div>
        </v-img>
        <!--
        <v-card-title>
            <h5 class="font-weight-bold text-truncate" :title="item.Short">
                <span v-text="item.Name"></span> 
            </h5>
        </v-card-title>
        <v-card-text class="mb-0 pb-0 d-none">
            <div v-html="item.Short" class="mr-2"></div>
        </v-card-text>
        <v-card-text class="mt-auto d-flex align-center">
            <v-chip small class="mr-1" v-for="t in item.TagNames" v-text="t" :key="t"></v-chip>
            <v-btn icon small @click="openDialog(item)" class="shrink ml-auto">
                <v-icon large color="black">mdi-home-circle</v-icon>
            </v-btn>
            <v-btn icon small target="_blank" :href="item.URL" class="shrink ml-1">
                <v-icon large color="primary">mdi-home-circle-outline</v-icon>
            </v-btn>
        </v-card-text>-->
    </v-card>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { TOGGLE_DIALOG_DETAILS, SET_RESOURCE_ACTIVE } from '@/store/mutation-types'

export default {
    name: 'CardResource',
    props: {
        heading: String,
        desc: String,
        viewName: String,
        item: Object,
        cardProps: Object,
    },
    data() {
        return {
            busy: false,
            selectedItem: {},
        }
    },
    computed: {
        ...mapState({
            resources: state => state.resource.resourcesByView,
            dialogDetails: state => state.resource.dialogDetails,
        }),
        imgHeight () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 190
                case 'sm': return 180
                case 'md': return 200
                case 'lg': return 220
                case 'xl': return 280
                default: return 190
            }
        },
    },
    methods: {
        ...mapMutations({
            setActiveResource: SET_RESOURCE_ACTIVE
        }),
        openDialog(item) {
            // console.log(item)
            this.selectedItem = { ...item }
            // console.log('selectedItem', this.selectedItem)
            // console.log('item', item.id, this.viewName)
            // this.$store.commit(SET_RESOURCE, this.selectedItem)
            this.setActiveResource(item.id)
            this.$store.commit(TOGGLE_DIALOG_DETAILS, { view: this.viewName, value: true })
        },
    },
}
</script>

<style scoped>
    .contrast {
        filter: contrast(110%);
    }
</style>